import updateSubscriptionSteps from 'app/utils/updateSubscriptionSteps';
import { CustomerUserImm, ProductIntakeImm } from 'app/types/admin/customerUser';
import * as Routes from 'app/constants/Routes';
import PriceCalculator from 'app/helpers/priceCalculator';
import GenericSubscriptionSummary from 'app/components/customer/steps/Payment/Generic/GenericSubscriptionSummary';
import React, { ReactNode } from 'react';
import PageHeader from 'app/components/common/PageHeader';
import { WarriorSubProducts, KingV2SubProducts } from 'app/constants/Products';
import { trackEvent } from 'app/utils/useCommonTracking';

class BaseCheckoutHelper {
  customer: CustomerUserImm;
  intake: ProductIntakeImm;
  isOnboarding: boolean;

  constructor(customer: CustomerUserImm, intake: ProductIntakeImm, isOnboarding: boolean = false) {
    this.customer = customer;
    this.intake = intake;
    this.isOnboarding = isOnboarding;
  }

  currentProductName() {
    throw new Error('Not implemented');
  }

  firstStep = () => updateSubscriptionSteps.paymentStep;

  secondStep = (_values: any) => updateSubscriptionSteps.planStep;

  productSpecificInitialValues() {
    throw new Error('Not implemented');
  }

  multimonthEnabled = () => false;

  multimonthPlansOptions = (_subProductName): { value: number; label: string }[] => [];

  updateSubProductCommandName = 'select_magician_drug_variant';

  selectProductStepPath() {
    return 'apologize';
  }

  selectPlanStepPath() {
    return 'apologize';
  }

  checkoutBreadcrumbs = (_dispatch, _onPlanChange: any = null, _onProductChange: any = null, _values: any = null) => '';

  redirectTo = (_params: any) => Routes.ManageSubscription;

  renderProductStep(_firstTimeChoice: boolean = false, _handleSubmit: any = null) {
    throw new Error('Not implemented');
  }

  renderProductStepHeader = (_values) => <PageHeader title="Choose Your Protocol" />;

  renderMultimonthStep(_handleChangeProduct, _firstTimeChoice: boolean = false): ReactNode {
    throw new Error('Not implemented');
  }

  renderPlanSelection(_onMultimonthUpdate, _subProductName, _priceCalculator) {
    throw new Error('Not implemented');
  }

  showLabAndDueTodaySection = (_params) => false;

  priceCalculator(_values: any, _subscription_paid: boolean = false, _lab_paid: boolean = false): PriceCalculator {
    throw new Error('Not implemented');
  }

  specialDisabledConditions(_values: any, _params): boolean {
    return false;
  }

  productChanged(_values: any): boolean {
    return false;
  }

  subscriptionSummaryComponent(): React.FC<any> {
    return GenericSubscriptionSummary;
  }

  kingV2Offered(): boolean {
    return false;
  }

  isKingV2OralTrt(_subProductName: any): boolean {
    return false;
  }

  isKingTrt(_subProductName: any): boolean {
    return false;
  }

  activeProductWithSupplementName(): string | undefined {
    return this.customer.get('active_product_with_supplement_name');
  }

  supplementsOnAnotherIntake = () => {
    return !!(
      this.activeProductWithSupplementName() && this.activeProductWithSupplementName() != this.currentProductName()
    );
  };

  crlFeatureEnabledEncloPregWeightLoss = (): boolean =>
    !!this.customer.get('crl_feature_enabled_enclo_preg_weight_loss');

  subProductName = (_values) => undefined;

  bbOutOfStock = () => this.intake.get('should_get_supplement_preorder');

  showLabKitOnboarding = () => false;

  subProductNameForIntakeCheckout() {
    return undefined;
  }

  showChangeProductButton = () => false;

  showLabSelectionButton = () =>
    this.isOnboarding && this.intake.get('steps').some((item) => item.get('name') === 'lab_selection');

  showOwnLabSection = () => false;

  useOwnLab = () => false;

  showProductSelectionStepNextButton = () => true;

  showMultimonthHeader = () => false;

  displayDermaOption = () => false;

  enableBuildingBlocks = () => true;

  recommendationSystemEnabled = () => false;

  recommendedSubProduct(): KingV2SubProducts | WarriorSubProducts | null | undefined {
    return undefined;
  }

  trackEvent(eventName: string, eventData: any) {
    trackEvent(eventName, { ...eventData });
  }

  trackRecommendationGenerated = () => {
    return;
  };

  recommendedBadge = (_values): any => null;

  showMultimonthPlansOptions = () => this.multimonthEnabled();
}

export default BaseCheckoutHelper;
